export default __webpack_public_path__ + "static/media/generate.36be573b.svg";